import React, { useState, Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './slide-form.styles'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { ModalContent } from 'pobble-components/dist/modal'
import FormRow from '../../../common/form-elements/form-row/form-row'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import CharactersCount from 'pobble-components/dist/form-elements/characters-count'
import {
  StickyEditor,
  EditorState,
  Controls,
  createStateFromHtml,
  stateToHTML
} from '../../../editor'

const TITLE_MAX_LENGTH = 90
const TEXT_MAX_LENGTH = 1000

const SlideForm = ({ classes, initialValues, onSubmit, footer }) => {
  const [editorState, setEditorState] = useState(
    !initialValues.text
      ? EditorState.createEmpty()
      : createStateFromHtml(initialValues.text)
  )
  return (
    <Formik
      onSubmit={values =>
        onSubmit({
          ...values,
          text: editorState.getCurrentContent().getPlainText(),
          html: stateToHTML(editorState)
        })
      }
      initialValues={initialValues}
      validationSchema={Yup.object().shape({
        title: Yup.string().required('Please provide a title'),
        text: Yup.string().required('Please provide some text')
      })}>
      {formikProps => {
        const {
          handleSubmit,
          handleBlur,
          handleChange,
          values,
          touched,
          errors,
          setFieldValue,
          setFieldTouched
        } = formikProps

        return (
          <form onSubmit={handleSubmit} className="metrics__slide-form">
            <ModalContent>
              <FormRow first>
                <FormLabel small spaceBetween htmlFor="createTextSlideTitle">
                  <span>Title of the slide</span>
                  <CharactersCount
                    value={values.title}
                    max={TITLE_MAX_LENGTH}
                  />
                </FormLabel>
                <FormInput
                  validationError={touched.title && errors.title}
                  placeholder="e.g. Poetry in the war"
                  id="createTextSlideTitle"
                  name="title"
                  className={classes.title}
                  value={values.title}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength={TITLE_MAX_LENGTH}
                  autoFocus={true}
                />
              </FormRow>
              <FormRow>
                <FormLabel small spaceBetween htmlFor="createTextSlideText">
                  <span>Main text</span>
                  <CharactersCount value={values.text} max={TEXT_MAX_LENGTH} />
                </FormLabel>
                <StickyEditor
                  onBlur={() => setFieldTouched('text')}
                  maxLength={TEXT_MAX_LENGTH}
                  error={!!touched.text && !!errors.text}
                  placeholder="Body of the slide"
                  controls={
                    <Fragment>
                      <Controls.Bold />
                      <Controls.Italic />
                      <Controls.Underline />
                      <Controls.Separator />
                      <Controls.UnorderedList />
                      <Controls.OrderedList />
                    </Fragment>
                  }
                  editorState={editorState}
                  onChange={newState => {
                    const plainText = newState
                      .getCurrentContent()
                      .getPlainText()
                    setFieldValue('text', plainText)
                    setEditorState(newState)
                  }}
                />
              </FormRow>
            </ModalContent>
            {footer(formikProps)}
          </form>
        )
      }}
    </Formik>
  )
}

export default injectSheet(styles)(SlideForm)
